import React from 'react'

import ConversationContent from './content'
import ConversationActions from './actions'

class Conversation extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  render () {
    const contentHeight = this.props.contentHeight || (this.props.height - this.props.actionsHeight)

    return (
      <div className='conversation-container'>
        <ConversationContent
          height={contentHeight}
          maxBubbleWidth={this.props.maxBubbleWidth}
          notificationOptions={this.props.notificationOptions}
          conversationContainerId={this.props.conversationContainerId}
          messageType={this.props.messageType}
          shouldLoadPreviousMessages={this.props.shouldLoadPreviousMessages}
          shouldLoadHistoryMessages={this.props.shouldLoadHistoryMessages}
          historyBatchLimit={this.props.historyBatchLimit}
          isRichMessageContentEnabled={this.props.isRichMessageContentEnabled}/>
        <ConversationActions
          ref='conversationActions'
          isActive={this.props.isActive}
          messageType={this.props.messageType}
          height={this.props.actionsHeight}
          conversationContainerId={this.props.conversationContainerId}
          to={this.props.to}
          warningMessage={this.props.warningMessage}
          onNewMessageInputFocus={this.props.onConversationFocus}
          onNewMessageInputBlur={this.props.onConversationBlur}
          shouldSendNotification={this.props.shouldSendNotification}
          otherUser={this.props.otherUser}/>
      </div>
    )
  }
}

Conversation.defaultProps = {
  height: 200,
  actionsHeight: 41,
  isActive: true
}

export default Conversation



/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/index.js
 **/